/**
 * CopilotPrepCard — the canonical AI Copilot module surface.
 *
 * One reusable primitive used across MentorDetail, EventDetail, PublicEvent,
 * Venture, etc. Renders:
 *   ┌ .ai-card (warm border + soft accent wash, adapts to dark mode) ┐
 *   │  [ ✨ COPILOT PREP ] (pill)                                     │
 *   │  Gradient-inked heading                                        │
 *   │  · plain-text bullet                                           │
 *   │  · plain-text bullet                                           │
 *   └────────────────────────────────────────────────────────────────┘
 *
 * All Copilot-authored blocks should use this. Do NOT roll a bespoke
 * `bg-gradient-to-br from-orange-50` block — it drifts.
 */
import { Sparkles } from 'lucide-react';

export function CopilotPrepCard({
  label = 'Copilot Prep',
  heading,
  items = [],
  children,
  right,
  className = '',
  testId,
}) {
  return (
    <div className={`ai-card ${className}`} data-testid={testId}>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="ai-chip">
          <Sparkles className="h-3.5 w-3.5" /> {label}
        </span>
        {right}
      </div>
      {heading && (
        <p className="ai-text font-display text-lg sm:text-xl leading-snug mt-4">
          {heading}
        </p>
      )}
      {items.length > 0 && (
        <ul className="mt-3 space-y-1.5 text-sm text-foreground/85">
          {items.map((t, i) => (
            <li key={i} className="leading-relaxed" data-testid={testId ? `${testId}-item-${i}` : undefined}>· {t}</li>
          ))}
        </ul>
      )}
      {children}
    </div>
  );
}

export default CopilotPrepCard;
